
import './App.css';
import NavBar from './components/NavBar';
import DownloadBanner from './components/downloadBanner';
import UserProfile from './screen/user_profile';
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from 'react';

function App() {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [bannerVisible, setBannerVisible] = useState(isMobile);


  useEffect(() => {
    setBannerVisible(isMobile)
  }, [isMobile])


  return (
    <div className="overlay flex flex-col ">
      <div className="content self-center" >

        <NavBar />
        {bannerVisible && (
          <div >
            <DownloadBanner visibility={setBannerVisible} />
          </div>
        )}
        <CustomRoutes />

      </div>
    </div>
  );
}
const CustomRoutes = () => {
  function cleanUserId(rawId) {
    return rawId.replace(/["\\]/g, '');
  }




  return (
    <Routes>
      <Route path="/user_profile/:id" element={<UserProfile />} />
      <Route path="/user_profile/redirect:id" element={<DefaultUserProfileRedirect />} />
      <Route path="/user_profile/redirect/:id" element={<DefaultUserProfileRedirect />} />
    </Routes>
  );
};

const DefaultUserProfileRedirect = () => {
  const location = useLocation()

  const redirectId = location.pathname.split("/");

  if (location.pathname.includes("/user_profile/redirect")) {
    return <Navigate to={`/user_profile/${redirectId[redirectId?.length - 1]}`} replace />;

  }


  return null;
};


export default App;